// i18n -> '@/locale/' 폴더에 파일 있습니다

let messages = require('./locale').default;

module.exports = {
  messages: messages
};



// WEBPACK FOOTER //
// ./src/added.js